import { ReactNode, useEffect, useState } from 'react';

import { PageContext } from './pageContext';
import { dictionary } from './dictionary';
import { MAIN_PORTAL_PATH } from '../../../routes/paths';
import { PAGE_TITLE } from '../consts';

const getMainPath = (path: string): MAIN_PORTAL_PATH => {
  const [, mainPath] = path.split('/') as [string, string];
  const detectedMainPath = `/${mainPath}` as MAIN_PORTAL_PATH;

  return detectedMainPath;
};

interface Props {
  children: ReactNode;
  currentPathname: string;
}

export const WithPage = ({ children, currentPathname }: Props) => {
  const [hasSubpages, setHasPageSubpages] = useState<boolean>();
  const [pageTitle, setPageTitle] = useState<PAGE_TITLE>();

  const handlePageInfo = (pathname: string) => {
    if (pathname) {
      const mainPath = getMainPath(pathname);
      const pageInfo = dictionary[mainPath];

      if (pageInfo) {
        setHasPageSubpages(pageInfo.hasSubpages);
        setPageTitle(pageInfo.title);
      }
    }
  };

  useEffect(() => {
    handlePageInfo(currentPathname);
  }, [currentPathname]);

  return <PageContext.Provider value={{ hasSubpages, pageTitle }}>{children}</PageContext.Provider>;
};
